import React from 'react';

export const ChevronRight = () => (
    <path d='M18.831,11.626l-13-11.5C5.626-0.058,5.309-0.039,5.125,0.169C4.942,0.376,4.962,0.691,5.169,0.874L17.746,12L5.169,23.126
		c-0.207,0.183-0.227,0.498-0.043,0.705C5.224,23.943,5.362,24,5.5,24c0.118,0,0.236-0.041,0.331-0.126l13-11.5
		C18.938,12.279,19,12.144,19,12S18.938,11.721,18.831,11.626z' />
);
